export default __webpack_public_path__ + "static/media/filter.1b065ec2.svg";